import Header from "../../Header";

export default function ColumnsHeader({ columnList, actionItemsCounts }) {
  return (
    <div className="flex">
      {columnList &&
        columnList.length > 0 &&
        columnList.map((column) => {
          const item = column?.id.toString();
          return (
            <Header
              key={"header_" + column?.id}
              title={column?.display ?? ""}
              count={
                actionItemsCounts && Object.prototype.hasOwnProperty.call(actionItemsCounts, item)
                  ? actionItemsCounts[item]
                  : 0
              }
            />
          );
        })}
    </div>
  );
}
